import React, { Component, useState } from 'react';
import { FormattedMessageWrappedInSpan } from '../../../components/misc';



const JobDeveloperWebsite = ({ setShowJob, showJob, job, ...props }) => {

  return (
    <>
    { job == "developerWebsite" &&
      <div className="container-960 container-page">
        <h2>
          <FormattedMessageWrappedInSpan id="jobsPage.developerWebsite.headline" defaultMessage="Placeholder" />
        </h2>
        <br />
        <br />
        <b>
          <FormattedMessageWrappedInSpan id="jobsPage.developerWebsite.aboutus.title" defaultMessage="Placeholder" />
        </b>
        <p>
          <FormattedMessageWrappedInSpan
            id="jobsPage.developerWebsite.aboutus.text"
            defaultMessage="Placeholder"
            values={{
              br: <br />,
            }}
          />
        </p>
        <b>
          <FormattedMessageWrappedInSpan id="jobsPage.developerWebsite.yourroll.title" defaultMessage="Placeholder" />
        </b>
        <span>
          <ul>
            <li>
              <FormattedMessageWrappedInSpan id="jobsPage.developerWebsite.yourroll.bullet1" defaultMessage="Placeholder" />
            </li>
            <li>
              <FormattedMessageWrappedInSpan id="jobsPage.developerWebsite.yourroll.bullet2" defaultMessage="Placeholder" />
            </li>
            <li>
              <FormattedMessageWrappedInSpan id="jobsPage.developerWebsite.yourroll.bullet3" defaultMessage="Placeholder" />
            </li>
          </ul>
        </span>
        <b>
          <FormattedMessageWrappedInSpan id="jobsPage.developerWebsite.needs.title" defaultMessage="Placeholder" />
        </b>
        <span>
          <ul>
            <li>
              <FormattedMessageWrappedInSpan id="jobsPage.developerWebsite.needs.bullet1" defaultMessage="Placeholder" />
            </li>
            <li>
              <FormattedMessageWrappedInSpan id="jobsPage.developerWebsite.needs.bullet2" defaultMessage="Placeholder" />
            </li>
            <li>
              <FormattedMessageWrappedInSpan id="jobsPage.developerWebsite.needs.bullet3" defaultMessage="Placeholder" />
            </li>
            <li>
              <FormattedMessageWrappedInSpan id="jobsPage.developerWebsite.needs.bullet4" defaultMessage="Placeholder" />
            </li>
            <li>
              <FormattedMessageWrappedInSpan id="jobsPage.developerWebsite.needs.bullet5" defaultMessage="Placeholder" />
            </li>
            <li>
              <FormattedMessageWrappedInSpan id="jobsPage.developerWebsite.needs.bullet6" defaultMessage="Placeholder" />
            </li>
            <li>
              <FormattedMessageWrappedInSpan id="jobsPage.developerWebsite.needs.bullet7" defaultMessage="Placeholder" />
            </li>
          </ul>
        </span>
        <b>
          <FormattedMessageWrappedInSpan id="jobsPage.developerWebsite.offer.title" defaultMessage="Placeholder" />
        </b>
        <span>
          <ul>
            <li>
              <FormattedMessageWrappedInSpan id="jobsPage.developerWebsite.offer.bullet1" defaultMessage="Placeholder" />
            </li>
            <li>
              <FormattedMessageWrappedInSpan id="jobsPage.developerWebsite.offer.bullet2" defaultMessage="Placeholder" />
            </li>
            <li>
              <FormattedMessageWrappedInSpan id="jobsPage.developerWebsite.offer.bullet3" defaultMessage="Placeholder" />
            </li>
            <li>
              <FormattedMessageWrappedInSpan id="jobsPage.developerWebsite.offer.bullet4" defaultMessage="Placeholder" />
            </li>
            <li>
              <FormattedMessageWrappedInSpan id="jobsPage.developerWebsite.offer.bullet5" defaultMessage="Placeholder" />
            </li>
            <li>
              <FormattedMessageWrappedInSpan id="jobsPage.developerWebsite.offer.bullet6" defaultMessage="Placeholder" />
            </li>
            <li>
              <FormattedMessageWrappedInSpan id="jobsPage.developerWebsite.offer.bullet7" defaultMessage="Placeholder" />
            </li>
            <li>
              <FormattedMessageWrappedInSpan id="jobsPage.developerWebsite.offer.bullet8" defaultMessage="Placeholder" />
            </li>
          </ul>
        </span>
        <b>
          <FormattedMessageWrappedInSpan id="jobsPage.developerWebsite.contact.title" defaultMessage="Placeholder" />
        </b>
        <p>
          <FormattedMessageWrappedInSpan
            id="jobsPage.developerWebsite.contact.contact"
            defaultMessage="Placeholder"
          />
        </p>
        <br />
        <button className="secondary" onClick={() => setShowJob(!showJob)}>
          <FormattedMessageWrappedInSpan
            id="jobsPage.back"
            defaultMessage="back"
          />
        </button>
      </div>
      }
      </>
  )
}

export default JobDeveloperWebsite
